import { render } from "./YPCategory.vue?vue&type=template&id=027acaae&scoped=true"
import script from "./YPCategory.vue?vue&type=script&lang=js"
export * from "./YPCategory.vue?vue&type=script&lang=js"

import "./YPCategory.vue?vue&type=style&index=0&id=027acaae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027acaae"]])

export default __exports__